import React, { useState, useEffect } from "react";
import { createTheme, makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import Avatar from "@material-ui/core/Avatar";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Grid from "@material-ui/core/Grid";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import TextField from "@material-ui/core/TextField";
const axios = require("axios");
const jwt = require("jsonwebtoken");
const _ = require("lodash");
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    fontSize: "8em",
    color: "white",
    backgroundColor: "#26477c",
  },
}));

const theme = createTheme({
  palette: {
    primary: { main: "#26477c" },
  },
});

const RFIDTagPage = ({ currentOrganisation }) => {
  let history = useHistory();
  const classes = useStyles();
  let [listOfNFC, setlListOfNFC] = useState("");
  const [open, setOpen] = useState(false);
  const [error, triggerError] = useState(false);
  const [errorMessage, triggerErrorMsg] = useState(false);
  const [assignUser, setAssignUser] = useState("");
  const [currentTagID, setCurrentTagID] = useState("");

  useEffect(async () => {
    // if (currentOrganisation !== "ntuGomic") {
    //   history.push("/dashboard/equipment");
    // }
    let authObj = Cookies.get("authObj");
    let token;
    if (authObj) {
      authObj = JSON.parse(authObj);
      token = authObj["token"];
    }
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    if (!listOfNFC) {
      let nfcData = await axios.get(
        `${process.env.REACT_APP_API}/allNFCs`,
        config
      );
      nfcData = nfcData.data.nfc;
      setlListOfNFC(nfcData);
    }
  }, []);
  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = (params) => {
    setOpen(true);
    if (error) {
      triggerError(false);
    }
    if (errorMessage) {
      triggerErrorMsg(false);
    }
  };

  const handleCloseAndConfirm = async () => {
    //
    let parsedUser = assignUser;

    Cookies.set("page", `Edit User`);
    let authObj = Cookies.get("authObj");
    authObj = JSON.parse(authObj);
    let { token } = authObj;

    //call api to assign user
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    let body = {
      vendorName: parsedUser,
      tagID: currentTagID,
    };
    let reassignUser = await axios.post(
      `${process.env.REACT_APP_API}/reAssignTag`,
      body,
      config
    );

    let success = reassignUser.data.success;

    if (!success) {
      triggerErrorMsg(reassignUser.data.message);
      triggerError(true);
    } else {
      //fire update RPI
      let fireRPI = await axios.post(
        `${process.env.REACT_APP_API}/gomicAPIWrapper`,
        {
          action: "fireRPI",
        },
        config
      );

      //fetch latest nfc list
      let nfcData = await axios.get(
        `${process.env.REACT_APP_API}/allNFCs`,
        config
      );
      nfcData = nfcData.data.nfc;
      setlListOfNFC(nfcData);
      setOpen(false);
    }
  };

  if (listOfNFC) {
    console.log(listOfNFC);
    let columns = [
      {
        editable: false,
        hide: false,
        headerName: "Tag Number",
        field: "tagID",
        width: 160,
      },
      {
        editable: false,
        hide: false,
        headerName: "Tag ID",
        field: "eventId",
        width: 160,
      },
      {
        editable: false,
        hide: false,
        headerName: "Tag Status",
        field: "CardStatus",
        width: 180,
      },
      {
        editable: false,
        hide: false,
        headerName: "Location",
        field: "username",
        width: 270,
      },
      {
        field: "edit",
        headerName: "Reassign User",
        width: 180,
        renderCell: (params) => {
          return (
            <div>
              <EditIcon
                color={"primary"}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleClickOpen(params);
                }}
              />
            </div>
          );
        },
      },
      {
        field: "revoke",
        headerName: "Revoke",
        width: 180,
        renderCell: (params) => {
          return (
            <div>
              <DeleteIcon
                color={"primary"}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // handleClickOpen(params);
                }}
              />
            </div>
          );
        },
      },
    ];

    listOfNFC = _.orderBy(listOfNFC, ["tagID"], ["asc"]);
    for (let i = 0; i < listOfNFC.length; i++) {
      let nfc = listOfNFC[i];
      listOfNFC[i]["id"] = i;
    }

    let datagridData = { columns: columns, rows: listOfNFC };
    let diagloueContentText = (
      <DialogContentText>
        <span>Change User</span>
        <div>
          <TextField
            error={error}
            helperText={errorMessage ? errorMessage : null}
            // defaultValue={newUserName ? newUserName : username}
            style={{ width: "100%" }}
            onChange={(event) => {
              setAssignUser(event.target.value);
            }}
            variant="outlined"
            margin="normal"
            required
            id="username"
            label="User Name"
            name="username"
            autoComplete="username"
            autoFocus
          />
        </div>
      </DialogContentText>
    );
    // let diagloueContentText = (
    //   <DialogContentText>
    //     <span>
    //       Are you sure to revoke this user <strong>{selectedUserName}</strong>
    //     </span>
    //   </DialogContentText>
    // );
    return (
      <div style={{ height: 620 }}>
        <ThemeProvider theme={theme}>
          {/* <Grid container spacing={1}>
            <Grid
              style={{
                display: "flex",
                justifyContent: "right",
              }}
              item
              xs={12}
            >
              <span
                onClick={() => {
                  history.push(`/dashboard/adminAddUser`);
                }}
                style={{ cursor: "pointer" }}
              >
                <PersonAddIcon color={"primary"} />
              </span>
            </Grid>
          </Grid> */}
          <div>&nbsp;</div>
          <DataGrid
            {...datagridData}
            onCellClick={async (event) => {
              let field = event.field;
              let nfcDetails = event.row;
              let { tagID, eventId } = nfcDetails;

              if (field === "edit") {
                setCurrentTagID(tagID);
                // reassign the user

                //
                console.log(event);
              }

              if (field === "revoke") {
                let token;
                let authObj = Cookies.get("authObj");
                if (authObj) {
                  authObj = JSON.parse(authObj);
                  token = authObj["token"];
                }
                let apiKeys = {
                  admin: "jnjirej9reinvuiriuerhuinui",
                  serviceUser: "juit959fjji44jcion4moij0kc",
                };
                let config = {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    apikey: apiKeys["admin"],
                  },
                };
                let body = {
                  tagID: eventId,
                };

                let unassignNFC = await axios.post(
                  `${process.env.REACT_APP_API}/unAssignTag`,
                  body,
                  config
                );

                //fire update RPI
                let fireRPI = await axios.post(
                  `${process.env.REACT_APP_API}/gomicAPIWrapper`,
                  {
                    action: "fireRPI",
                  },
                  config
                );

                console.log(fireRPI);

                let nfcData = await axios.get(
                  `${process.env.REACT_APP_API}/allNFCs`,
                  config
                );

                nfcData = nfcData.data.nfc;
                setlListOfNFC(nfcData);
                // console.log(unassignNFC);
              }
            }}
            // onEditCellChangeCommitted={handleEditCellChangeCommitted}
            filterModel={{
              items: [
                // {
                //   columnField: 'commodity',
                //   operatorValue: 'contains',
                //   value: 'rice',
                // },
              ],
            }}
          />
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            {/* <DialogTitle id='form-dialog-title'>Subscribe</DialogTitle> */}
            <DialogContent>{diagloueContentText}</DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button onClick={handleCloseAndConfirm} color="primary">
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </div>
    );
  } else {
    return <>Pages Loading...</>;
  }
};

export default RFIDTagPage;
